module.exports = __webpack_public_path__ + "static/img/0542_3.355121c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/home/img/0542_3.jpg
// module id = nmhf
// module chunks = 1